'use strict';

const saParseNameInput = function () {
  return {
    restrict: 'A',
    require: ['saParseNameInput', 'ngModel'],
    controller: [
      function () {
        var ngModel;

        function parseInput(inputValue) {
          var transformedInput = inputValue;

          if (inputValue) {
            transformedInput = transformedInput.replace(/[0-9]/g, '');
            transformedInput = transformedInput.replace(/(.)\1\1/gi, '$1$1');
            transformedInput = transformedInput.replace(/[\\\[\]\^<,\-_"@\/\{\}\(\)\*\$%\?=>:\|;\.!%±~§#'`\+]/i, '');
            transformedInput = transformedInput.charAt(0).toUpperCase() + transformedInput.slice(1);
          }
          if (transformedInput !== inputValue) {
            ngModel.$setViewValue(transformedInput);
            ngModel.$render();
          }

          return inputValue;
        }

        this.init = function (ngModelCtrl) {
          ngModel = ngModelCtrl;
          ngModel.$parsers.push(parseInput);
        };
      }
    ],
    link: function postLink(scope, element, attrs, ctrls) {
      ctrls[0].init(ctrls[1]);
    }
  };
};

export default saParseNameInput;



// WEBPACK FOOTER //
// ./app/src/directives/parse_name_input.directive.js